import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { sprintf } from 'sprintf-js';

import { environment } from '../../environments/environment';
import { BaseService } from './base.service';

@Injectable()
export class CoreEventInquiryService extends BaseService {

  constructor(
    protected http: HttpClient,
  ) {
    super(http, `${environment.apiBaseUrl}/companies/%(company_id)s/core_events/%(event_id)s/inquiries`);
  }

  addMessage(model: any, urlParams: any, apiParams: any = {}): Observable<any> {
    const url = sprintf(`${environment.apiBaseUrl}/companies/%(company_id)s/core_events/%(event_id)s/inquiries/%(inquiry_id)s/messages`, urlParams);
    return this.http.post<any>(url, model, { params: this.toHttpParams(apiParams) });
  }

  deleteMessage(urlParams: any, apiParams: any = {}): Observable<any> {
    const url = sprintf(`${environment.apiBaseUrl}/companies/%(company_id)s/core_events/%(event_id)s/inquiries/%(inquiry_id)s/messages/%(message_id)s`, urlParams);
    return this.http.delete<any>(url, { params: this.toHttpParams(apiParams) });
  }
}
